import axiosInstance from '../../../config/axios';

export interface EmployeeRoles {
  role: 'EMPLOYEE' | 'MANAGER' | 'ADMIN';
  work_area_ids: number[];
  permissions: {
    can_approve_absences: boolean;
    can_manage_shifts: boolean;
    can_view_compensation: boolean;
    require_compensation_pin: boolean;
    can_view_profile: boolean;
    can_view_documents: boolean;
  };
  has_user?: boolean;
  can_update?: boolean;
  blocked_reason?: string;
}

export interface EmployeeRolesUpdatePayload {
  role: 'EMPLOYEE' | 'MANAGER' | 'ADMIN';
  work_area_ids?: number[];
  permissions?: {
    can_approve_absences?: boolean;
    can_manage_shifts?: boolean;
    can_view_compensation?: boolean;
    require_compensation_pin?: boolean;
    can_view_profile?: boolean;
    can_view_documents?: boolean;
  };
}

interface InvitePayload {
  first_name: string;
  last_name: string;
  email: string;
  employee: number;
}

class EmployeeRolesService {
  async getRoles(employeeId: number): Promise<EmployeeRoles> {
    try {
      const response = await axiosInstance.get<EmployeeRoles>(`/api/employees/${employeeId}/roles/`, {
        params: { _ts: Date.now() },
      });
      return response.data;
    } catch (err: any) {
      const status = err?.response?.status;

      if (!err?.response || status === 404) {
        const fallbackResponse = await axiosInstance.get<EmployeeRoles>(
          `/api/admin/employees/${employeeId}/roles/`,
          { params: { _ts: Date.now() } }
        );
        return fallbackResponse.data;
      }

      throw err;
    }
  }

  async updateRoles(employeeId: number, payload: EmployeeRolesUpdatePayload): Promise<EmployeeRoles> {
    const response = await axiosInstance.put<EmployeeRoles>(`/api/employees/${employeeId}/roles/`, payload);
    return response.data;
  }

  async sendInvite(payload: InvitePayload): Promise<void> {
    await axiosInstance.post('/api/admin/users/invitations/', payload);
  }

  async createAccount(employeeId: number): Promise<void> {
    await axiosInstance.post(`/api/employees/${employeeId}/activate-user/`);
  }
}

export default new EmployeeRolesService();
